import { generateMnemonic } from 'bip39';
import CryptoJS from 'crypto-js';
import sha256 from 'crypto-js/sha256';
import {kbUserData} from "../utils";
import {publicChatData} from "./utils";

export function emailToUserId(email, domain = null) {
    const input = domain
        ? email.toLowerCase() + ':' + domain.toLowerCase()
        : email.toLowerCase();
    return sha256(input).toString().substring(0, 16);
}

export function generateItemId(title) {
    return sha256(title).toString().substring(0, 32);
}

export const generatePassphrase = () => {
    return generateMnemonic(128); // 128 bits (16 words) passphrase
};

export function generateUUID(length = 12) {
    const randomBytes = new Uint32Array(8);
    window.crypto.getRandomValues(randomBytes);

    return Array.from(randomBytes)
        .map(num => num.toString(36))
        .join('')
        .slice(0, length);
}

export const generateKey = (passphrase) => {
    if (!passphrase) passphrase = generatePassphrase();
    const keySize = 256 / 32;
    const iterations = 1000;
    const hasher = CryptoJS.algo.SHA256;
    const passphraseWA = CryptoJS.enc.Latin1.parse(passphrase);
    const saltWA = CryptoJS.enc.Latin1.parse('salt');
    const key = CryptoJS.PBKDF2(passphraseWA, saltWA, { keySize, iterations, hasher }).toString();
    return key;
};

export const decrypt = (ciphertext, key) => {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, key);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        // console.log('Unable to decrypt', e.toString())
        return ciphertext;
    }
};

export const setKBKey = (kbId, key) => {
    if (!key || key?.length < 16) {
        console.log('Incorrect Key:', key);
        return;
    }
    return localStorage.setItem(`aesKey-${kbId}`, key);
}

export const getKBKey = (kbId) => {
    return localStorage.getItem(`aesKey-${kbId}`);
}

export const encrypt = (text, key) => {
    return CryptoJS.AES.encrypt(text, key).toString();
};

export const encryptKBDataWithoutPrivateKey = (KBData) => {
    return {
        ...KBData,
        kbTitle: encryptKBItem(KBData.kbTitle),
        kbDescription: encryptKBItem(KBData.kbDescription),
        kbInstructions: encryptKBItem(KBData.kbInstructions),
    }
}

export const encryptKBItem = (item, kbId, aesKey) => {
    if (publicChatData) return item
    kbId = kbId || kbUserData()?.kbId;
    const storedKey = aesKey || localStorage.getItem(`aesKey-${kbId}`);

    // Add a prefix to indicate the type of the original value
    if (typeof item === 'number') item = `__OPENKBS__NUM__${item}`;
    return encrypt(item, storedKey);
};

export const decryptKBItem = (item, kbId) => {
    if (item === undefined) return item;
    if (!kbId) kbId = kbUserData()?.kbId;

    try {
        const storedKey = localStorage.getItem(`aesKey-${kbId}`);
        const decryptedItem = storedKey ? decrypt(item, storedKey) : item;

        // Check for the prefix and convert the value back to its original type
        if (decryptedItem.startsWith('__OPENKBS__NUM__')) return parseFloat(decryptedItem.replace('__OPENKBS__NUM__', ''));

        return decryptedItem;
    } catch (e) {
        // console.log('Unable to decryptKBItem', e.toString())
        return item;
    }
};

export const decryptKBItemIfEncrypted = (item, kbId) => {
    const res = decryptKBItem(item, kbId)
    if (item && !res) return item; // is decryption fails return the initial value
    return res;
}

export const getItemImageUrl = ({item, meta}) => {
    // meta?.itemType is undefined on IndexedDB
    if (meta?.itemType === 'page' && item?.image) {
        const decryptedImageURL = decryptKBItemIfEncrypted(item.image);
        if (decryptedImageURL?.startsWith('http')) {
            return { imageUrl: decryptedImageURL, imageUrlAttributeName: 'image' }
        }
    }


}